import {
  ChipNavLinkExternal,
  ChipNavLinkInternal,
} from "../../atoms/ChipNavigation";
import { ExternalLinkSimpleSmIcon } from "../../atoms/Icons";

export default function MenuSecondaryNav({
  menuItemsSecondary,
  isInTopBar,
  setOpenModal,
  setOpenModalSmall,
}) {
  return (
    <ul
      className={`flex gap-12 ${
        isInTopBar
          ? "hidden 640:flex"
          : "flex flex-wrap 640:hidden mt-64 border-t border-gray-300 py-16"
      }`}
    >
      {menuItemsSecondary &&
        menuItemsSecondary.length > 0 &&
        menuItemsSecondary.map((item, index) =>
          item.internal ? (
            <li key={index}>
              <ChipNavLinkInternal
                onClick={() => {
                  setOpenModal(null);
                  setOpenModalSmall(false);
                }}
                text={item.title}
                link={item.slug}
              />
            </li>
          ) : (
            <li key={index}>
              <ChipNavLinkExternal
                text={item.title}
                link={item.slug}
                icon={<ExternalLinkSimpleSmIcon extraClass="stroke-gray-900" />}
                iconRight
              />
            </li>
          )
        )}
    </ul>
  );
}
